import { memo } from 'react';
import { Zoom } from '../../mui/Zoom';
import { Dialog, DialogProps } from '../../mui/Dialog';
import { Box } from '../../mui/Box';
import { Stack } from '../../mui/Stack';
import { DialogTitle } from '../../mui/DialogTitle';
import { DialogContentText } from '../../mui/DialogContentText';
import { Divider } from '../../mui/Divider';
import { IconButton } from '../../mui/IconButton';
import { IoClose } from '../Icons/ion5';

type ModalOnClose = (event?: Record<string, unknown>, reason?: 'backdropClick' | 'escapeKeyDown') => void;

export interface ControllerModalProps extends DialogProps {
  onClose: ModalOnClose;
  requiredFields?: boolean;
  subTitle?: React.ReactNode;
  title: string;
}

export const ControllerModal = memo(function ({
  children,
  onClose,
  open,
  requiredFields,
  subTitle,
  title,
  ...other
}: ControllerModalProps) {
  const handleDialogClose: ModalOnClose = (_, reason) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  };

  const handleButtonClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleDialogClose} open={open} {...other} TransitionComponent={Zoom}>
      <DialogTitle>
        <Stack direction='column' spacing={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{title}</span>
            <IconButton color='inherit' onClick={handleButtonClose}>
              <IoClose />
            </IconButton>
          </Box>
          <Divider />
          {!!subTitle && <DialogContentText>{subTitle}</DialogContentText>}
          {requiredFields && (
            <DialogContentText
              sx={(theme) => ({
                ...theme.typography.caption,
                color: theme.palette.grey[600],
              })}
            >
              <Box component='span' sx={{ color: 'error.main' }}>
                *
              </Box>{' '}
              Indicates a required field
            </DialogContentText>
          )}
        </Stack>
      </DialogTitle>
      {children}
    </Dialog>
  );
});

ControllerModal.displayName = 'ControllerModal';
